type ChannelMessageId = 'reloadAllTabs';

const broadcastChannel = new BroadcastChannel('deed');

export const dispatchMessage = (messageId: ChannelMessageId) => {
  broadcastChannel.postMessage(messageId);
};

export const handleMessage = (messageId: ChannelMessageId, listener: () => void) => {
  broadcastChannel.addEventListener('message', (event) => {
    if (event.data === messageId) {
      listener();
    }
  });
};
